module.exports = __webpack_public_path__ + "img/charge.66a09383.jpg";